import React from 'react';
import { NistFunctionPage } from '../../../components/assessment/nist/NistFunctionPage';
import { NIST_FUNCTIONS } from '../../../utils/nistAiRmf';
export function GovernFunction() {
  const functionData = NIST_FUNCTIONS.find(f => f.id === 'Govern')!;
  return <NistFunctionPage functionId="Govern" title={functionData.title} description={functionData.description} nextPath="/assessment/nist/map" prevPath="/assessment/regulation" data-id="element-473" />;
}